import React, { FC } from 'react';
import styled from 'styled-components';

import App from 'models/app';

import { Screenshot } from '../../../types/app';

import { DEVICE_PLACEHOLDERS } from 'config';
import { Link } from '../Common';
import { TileContainer, TileImage } from '../ImageContainer/TileImage';

const DEVICES: any = DEVICE_PLACEHOLDERS;
const DEFAULT_TILE_WIDTH = 73;
const DEFAULT_TILE_WIDTH_BEZELS = 82;

interface TilesRowProps {
  favoriteTiles: App[];
  maxFavoriteTiles: number;
  deviceName: string;
  screenshot: Screenshot;
}

const TilesRowContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  padding: 10px 10px 24px;
`;

const StyledLinkContainer = styled.div`
  display: flex;
  flex: 0 0 21%;
`;

const createPlaceholders = ({ count, deviceName, screenshot }: any) => {
  const placeholders = [];

  const deviceIcon = DEVICES[deviceName]?.tileEmptySlot;
  if (!deviceIcon) {
    return null;
  }

  for (let i = 0; i < count; i += 1) {
    const placeholderScreenshot = {
      height: screenshot?.height,
      width: screenshot?.width,
      uri: deviceIcon
    }

    placeholders.push((
      <StyledLinkContainer key={i}>
        <Link
          to={'/v2/tiles/gallery'}
          pageDirection='FORWARD'
          id={'tiles-gallery'}
          aria-label={'tiles-gallery'}
          key={`tile-placeholder-${i}`}
        >
          <TileContainer size={placeholderScreenshot} tileBezelWidth={DEFAULT_TILE_WIDTH_BEZELS}>
            <TileImage
              image={placeholderScreenshot}
              name={`placeholder ${i}`}
              tileWidth={DEFAULT_TILE_WIDTH}
            />
          </TileContainer>
        </Link>
      </StyledLinkContainer>
    ));
  }

  return placeholders;
};

const TilesRow: FC<TilesRowProps> = ({
  favoriteTiles = [],
  deviceName,
  maxFavoriteTiles,
  screenshot
}) => (
  <TilesRowContainer>
    {favoriteTiles
      .map((app) => {
        let premiumTileIcon;
        if (app.isPremium) {
          premiumTileIcon = DEVICES[deviceName]?.premiumTileIcon;
        }
        return (
          <StyledLinkContainer key={`tile-${app.id}`}>
            <Link
              to={`/v2/tile/${app.id}`}
              pageDirection='FORWARD'
              id={`tile-${app.id}`}
              aria-label={app.name}
              key={`link-${app.id}`}
            >
              <TileContainer
                size={app.banners[0]}
                premiumTileIcon={premiumTileIcon}
                tileBezelWidth={DEFAULT_TILE_WIDTH_BEZELS}
              >
                <TileImage
                  image={app.banners[0]}
                  name={app.name}
                  tileWidth={DEFAULT_TILE_WIDTH}
                />
              </TileContainer>
            </Link>
          </StyledLinkContainer>
      )})}
    {createPlaceholders({
      count: maxFavoriteTiles - favoriteTiles.length,
      deviceName,
      screenshot: (favoriteTiles || []).length ? favoriteTiles[0].banners[0] : screenshot
    })}
  </TilesRowContainer>
);

export default TilesRow;
